"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var sentry_1 = __importDefault(require("./sentry"));
var appHandlers = [
    "keyboardStateChanged",
    "onScreenVisibility",
    "BUILD_IM_CART",
    "openDeeplink",
    "LOGIN_STATE_CHANGED",
    "allowNativeBottomBarExit",
    "handleHardwareBack",
    "SEARCH_QUERY_INPUT",
    "swipeBottomsheet",
    "HANDLE_IM_SEARCH_ACTIONS",
    "onHalfCardBackgroundTap",
    "UPDATE_SELECTED_ADDRESS",
];
var ErrorBoundary = /** @class */ (function (_super) {
    __extends(ErrorBoundary, _super);
    function ErrorBoundary() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            hasError: false,
        };
        _this.SentryService = new sentry_1.default({ dsn: _this.props.dsn });
        _this.captureException = function (err) {
            _this.SentryService.logError(err);
            return false;
        };
        _this.captureDidCatchException = function (error, errorInfo) {
            _this.SentryService.withScopeAdded(error, errorInfo);
            _this.props.onErrorCapture(error, errorInfo);
            _this.setState({ hasError: true });
        };
        return _this;
    }
    ErrorBoundary.prototype.componentDidMount = function () {
        var _this = this;
        window.addEventListener("unhandledrejection", this.captureException);
        window.addEventListener("error", this.captureException);
        appHandlers
            .filter(function (handler) { var _a; return (((_a = _this.props.excludeLists) === null || _a === void 0 ? void 0 : _a.indexOf(handler)) || -1) > -1; })
            .forEach(function (handler) {
            // @ts-ignore
            window[handler] = function () { };
        });
    };
    ErrorBoundary.prototype.componentWillUnmount = function () {
        window.removeEventListener("unhandledrejection", this.captureException);
        window.removeEventListener("error", this.captureException);
    };
    ErrorBoundary.prototype.componentDidCatch = function (error, errorInfo) {
        this.captureDidCatchException(error, errorInfo);
    };
    ErrorBoundary.prototype.render = function () {
        if (this.state.hasError) {
            return React.createElement(React.Fragment, null, this.props.ErrorComponent());
        }
        return React.createElement(React.Fragment, null, this.props.children);
    };
    return ErrorBoundary;
}(React.PureComponent));
exports.default = ErrorBoundary;
